// removed by extract-text-webpack-plugin
module.exports = {"pricingWrapper":"_2rTIJq78zeISJ7xFkmkAr","couponWrapper":"_1_aANA3skAuaAX0J7-H9a-","title":"_2rL7F4oUld_HvG0R_ixM1G","smallTitle":"rcJwMnN6i137DXNxqnX9V","total":"_3PqXaf4O45Sl7e7UVRxHSz","couponBonus":"_2ot1hxqzVnx7TKR4W4JNFu","priceItem":"_1214UxybdhXz7FStBWwWkB","boldText":"_3tqSihMqoajv6xorcODmkr"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/PackagesBlock/PackagesBlock.scss
// module id = 1826
// module chunks = 0